module.exports = __webpack_public_path__ + "img/14.b5f81eb6.jpg";